import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      width: "24",
      height: "24",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#D9D9D9",
        d: "M0 0h24v24H0z"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#114A4E",
        d: "M17 20.725a.73.73 0 0 1-.535-.216.73.73 0 0 1-.215-.534v-2.25H14a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534q0-.32.216-.535a.73.73 0 0 1 .534-.215h2.25v-2.25q0-.319.216-.534a.73.73 0 0 1 .534-.216q.32 0 .535.216a.73.73 0 0 1 .215.534v2.25H20q.318 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.535a.73.73 0 0 1-.534.215h-2.25v2.25q0 .318-.216.534a.73.73 0 0 1-.534.216M5 17.75a.73.73 0 0 1-.534-.216A.73.73 0 0 1 4.25 17q0-.32.216-.535A.73.73 0 0 1 5 16.25h6.296q-.045.395-.034.752.013.358.06.748zm0-4a.73.73 0 0 1-.534-.216A.73.73 0 0 1 4.25 13q0-.32.216-.535A.73.73 0 0 1 5 12.25h8.727q-.431.304-.787.679t-.65.82zm0-4a.73.73 0 0 1-.534-.216A.73.73 0 0 1 4.25 9q0-.32.216-.535A.73.73 0 0 1 5 8.25h13q.318 0 .534.216A.73.73 0 0 1 18.75 9q0 .32-.216.535A.73.73 0 0 1 18 9.75zm0-4a.73.73 0 0 1-.534-.216A.73.73 0 0 1 4.25 5q0-.32.216-.535A.73.73 0 0 1 5 4.25h13q.318 0 .534.216A.73.73 0 0 1 18.75 5q0 .32-.216.535A.73.73 0 0 1 18 5.75z"
      })
    ], -1)
  ])))
}
export default { render: render }